import { createAuthStore, type AuthUser } from '@/shared/lib/auth-store-factory';

export type SystemRole = 'root' | 'commercial' | 'analyst';

const ALLOWED_ROLES: SystemRole[] = ['root', 'commercial', 'analyst'];

export const hasRole = (user?: AuthUser | null, role?: SystemRole): boolean => {
  if (!user?.system_role) return false;
  if (!role) return ALLOWED_ROLES.includes(user.system_role as SystemRole);
  return user.system_role === role;
};

export const useAdminAuthStore = createAuthStore({
  storageKey: 'examfy-admin-auth-storage',
  version: 3,
  logPrefix: 'Admin Auth',
  validateUser: (user: AuthUser) => ALLOWED_ROLES.includes(user.system_role as SystemRole),
});

export type { AuthUser as User };
